// 自定义照片上传功能
document.addEventListener('DOMContentLoaded', function() {
  const fileInputs = document.querySelectorAll('[data-custom-upload]');
  
  fileInputs.forEach(input => {
    const container = input.closest('.product-form__custom-upload');
    const previewEl = container.querySelector('[data-upload-preview]');
    const filenameEl = container.querySelector('[data-upload-filename]');
    const removeBtn = container.querySelector('[data-upload-remove]');
    
    input.addEventListener('change', function(e) {
      const file = this.files[0];
      if (file) {
        // 显示文件名
        filenameEl.textContent = file.name;
        
        // 创建预览
        const reader = new FileReader();
        reader.onload = function(e) {
          previewEl.innerHTML = `<img src="${e.target.result}" alt="预览图片">`;
          removeBtn.hidden = false;
        };
        reader.readAsDataURL(file);
      }
    });
    
    // 删除按钮功能
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        input.value = '';
        previewEl.innerHTML = '';
        filenameEl.textContent = '';
        this.hidden = true;
      });
    }
  });
});


// 自定义文本输入字符计数功能
document.addEventListener('DOMContentLoaded', function() {
  const textareas = document.querySelectorAll('.custom-text-input');
  
  textareas.forEach(textarea => {
    const container = textarea.closest('.product-form__custom-text');
    const counterEl = container.querySelector('[data-char-count]');
    const counterContainer = container.querySelector('.custom-text-counter');
    const maxLength = 100; // 最大字符数
    
    textarea.addEventListener('input', function() {
      const currentLength = this.value.length;
      counterEl.textContent = currentLength;
      
      if (currentLength >= maxLength) {
        counterContainer.classList.add('limit-reached');
        this.value = this.value.substring(0, maxLength);
        counterEl.textContent = maxLength;
      } else {
        counterContainer.classList.remove('limit-reached');
      }
    });
  });
});